import { Component, OnInit } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import { HelperService } from '../service/helper/helper.service';
import Swal from 'sweetalert2';

import { Router } from '@angular/router';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {

  addressList = [];
  Modalmap;
  ModalmapSize;
  BalanceList;

  constructor(public dialogRef: MatDialogRef<ModalComponent>,  public router: Router, public helper: HelperService) { }

  ngOnInit() {
    this.helper.balanceFiller()
    this.addressList = this.helper.accountList;
    this.BalanceList = this.helper.accountListBalance;
    //this.getUpdatedAcc();
    this.helper.newAcc.subscribe(x=>{
      console.log(this.helper.accountListBalance)
      this.addressList = this.helper.accountList;
      this.BalanceList = this.helper.accountListBalance;
    })
  }

  // getUpdatedAcc(){
  //  // this.helper.getUpdatedAcc().subscribe(x=>{
  //     console.log(JSON.parse(x))
  //   })
  // }

  selectAddress(addressPosition){
    this.helper.selectAddress(addressPosition);
  }

  route(linkName) {
    const link = ['/' + linkName];
    this.dialogRef.close();

    this.router.navigate(link);
  }

  removeWallet(){
    // this.helper.removeWallet();
    Swal.fire({
      title: 'Are you sure',
      text: 'You want to delete this wallet from this System?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        this.helper.removeWallet();
      }
      else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Your Wallet is safe',
          'error'
        )
      }
    })
  }

  giveBalance(address){
    console.log(address)
    // return this.BalanceList[i].address
  }

  close() {
    this.dialogRef.close();
  }

  AddAccount(){
    Swal.fire({
      title: 'Enter your wallet PIN',
      input: 'password',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Submit',
      // showLoaderOnConfirm: true,
      preConfirm: (key) => {
        this.helper.createAddress(key)
      },
      allowOutsideClick: () => !Swal.isLoading()
    })
    // .then((result) => {
    //   if (result.value) {
    //     Swal.fire({
    //       title: `${result.value.login}'s avatar`,
    //       imageUrl: result.value.avatar_url
    //     })
    //   }
    // })

  }


  // showMap(){
  //   this.Modalmap = this.helper.seeMap();
  //   console.log(this.Modalmap);
  //   this.addressList = this.Modalmap[0]
  //   this.BalanceList = this.Modalmap[1]

  //   console.log(this.BalanceList);
  // }


    // this.ModalmapSize = this.Modalmap.size;
    // console.log(this.ModalmapSize)
    // this.itAddress =  this.Modalmap.keys()
    // this.itBalance = this.Modalmap.values()
    // // console.log(this.Modalmap.keys(), this.Mapp.values())
    // console.log(this.itAddress.next().value)
    // console.log(this.itBalance.next().value)
    // console.log(this.helper.getAddressList());



}
